"use strict";

var _regeneratorRuntime = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _classCallCheck = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/build/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var serviceUtils_1 = require("./serviceUtils");

var fetchUtil_1 = require("../../fetchUtil");
/**
 * @ignore
 */


var Service = /*#__PURE__*/function () {
  function Service() {
    _classCallCheck(this, Service);
  }

  _createClass(Service, [{
    key: "validateProof",
    value: function validateProof(proof, ownerAddress, cheerio) {
      var name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      return tslib_1.__awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var proofUrl, res, text, proofText;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                proofUrl = this.getProofUrl(proof);
                _context.next = 4;
                return fetchUtil_1.fetchPrivate(proofUrl);

              case 4:
                res = _context.sent;

                if (!(res.status !== 200)) {
                  _context.next = 7;
                  break;
                }

                throw new Error("Proof url ".concat(proofUrl, " returned unexpected http status ").concat(res.status, ".\n            Unable to validate proof."));

              case 7:
                _context.next = 9;
                return res.text();

              case 9:
                text = _context.sent;

                if (!(this.shouldValidateIdentityInBody() && proof.identifier !== this.getProofIdentity(text, cheerio))) {
                  _context.next = 12;
                  break;
                }

                return _context.abrupt("return", proof);

              case 12:
                proofText = this.getProofStatement(text, cheerio);
                proof.valid = serviceUtils_1.containsValidProofStatement(proofText, name) || serviceUtils_1.containsValidAddressProofStatement(proofText, ownerAddress);
                return _context.abrupt("return", proof);

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](0);
                console.error(_context.t0);
                proof.valid = false;
                return _context.abrupt("return", proof);

              case 22:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 17]]);
      }));
    }
  }, {
    key: "shouldValidateIdentityInBody",
    value: function shouldValidateIdentityInBody() {
      return false;
    }
  }, {
    key: "prefixScheme",
    value: function prefixScheme(proofUrl) {
      if (!proofUrl.startsWith('https://') && !proofUrl.startsWith('http://')) {
        return "https://".concat(proofUrl);
      } else if (proofUrl.startsWith('http://')) {
        return proofUrl.replace('http://', 'https://');
      } else {
        return proofUrl;
      }
    }
  }, {
    key: "getProofIdentity",
    value: function getProofIdentity(searchText, _cheerio) {
      return searchText;
    }
  }]);

  return Service;
}();

exports.Service = Service;